// useClubeVitrine.js — os números do Clube para quem AINDA NÃO É CLIENTE.
//
// ================= POR QUE ELE EXISTE, SE JÁ HÁ useClube =================
//
// `useClube` responde "esta pessoa assina?", e para isso precisa de login: ele
// bate em `clube/status`, que devolve saldo de coins, histórico e vencimento.
// Numa tela vista por visitante anônimo ele não devolve nada — nem o preço.
//
// O efeito disso era uma cópia à mão: a página de venda do Clube escrevia
// "R$ 50,00" e "500 Insigne Coins" no JSX, com um comentário admitindo que era
// duplicação e explicando por quê. É a mesma cópia de preço que `config/coins.js`
// e o `PrecoService` existem para impedir — e, pior, na única tela em que o
// preço errado custa a venda inteira: a de quem ainda não é cliente.
//
// `clube/vitrine` é pública e não fala de pessoa nenhuma: preço, prazo, tamanho
// do acervo e quantos já assinam (esse último já vem zerado pelo servidor
// quando são poucos — ver AssinaturaService::totalAtivos).
//
// GET {API}clube/vitrine  (sem token)
import { useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_API;

// Cache de módulo: o catálogo, a página do clube e o perfil pedem os mesmos
// números na mesma visita. Sem isto seriam três requisições idênticas, e a do
// catálogo acontece justamente enquanto a lista de livros ainda está chegando.
let cache = null;

export default function useClubeVitrine() {
  const [dados, setDados] = useState(cache);
  const [carregando, setCarregando] = useState(!cache);

  useEffect(() => {
    if (cache) return;

    let vivo = true;
    (async () => {
      try {
        const r = await fetch(`${API_URL}clube/vitrine`);
        if (!r.ok) return;
        const d = await r.json();
        cache = d;
        if (vivo) setDados(d);
      } catch (_) {
        // Falhar aqui significa "não sabemos os números", e toda tela que usa
        // este hook sabe esconder o bloco nesse caso. Uma oferta que não
        // carrega tem de sumir, nunca aparecer com "R$ --".
      } finally {
        if (vivo) setCarregando(false);
      }
    })();

    return () => { vivo = false; };
  }, []);

  return {
    precoCentavos: Number(dados?.preco_centavos) || 0,
    precoCoins: Number(dados?.preco_coins) || 0,
    dias: Number(dados?.dias) || 0,
    acervo: Number(dados?.acervo_total) || 0,
    assinantes: Number(dados?.assinantes) || 0,
    // Os pacotes de Ticket, para a página de venda mostrar o preço POR MÊS de
    // cada um sem exigir login. Lista vazia quando não chegaram, e a seção some.
    pacotes: Array.isArray(dados?.pacotes) ? dados.pacotes : [],
    carregando,
  };
}
